export default "__VITE_ASSET__DZUUxMS___"